import React, {CSSProperties} from 'react'

type EditableTextChromeExtensionProps = {
  placeholder?: string
  value: string
  onChange: (value: string) => void
  editable?: boolean
  updateEditMode: (boolean: any) => void
  isParagraph?: boolean
  rows?: number
  cols?: number
  autoFocus?: boolean
  className?: string
  style?: CSSProperties
}

export default function EditableTextChromeExtension(props: EditableTextChromeExtensionProps) {
  const {style, placeholder, value, onChange, editable, updateEditMode, isParagraph, rows, cols, autoFocus, className} = props

  return (
    <React.Fragment>
      <React.Fragment>
        {isParagraph ? (
          <textarea
            rows={rows || 6}
            cols={cols || 62}
            style={{...style, cursor: !editable ? 'none' : 'pointer', pointerEvents: editable ? undefined : 'none'}}
            className={className}
            value={value}
            placeholder={placeholder}
            onClick={() => updateEditMode(true)}
            onChange={(event) => {
              onChange(event.target?.value ?? '')
            }}
            wrap="hard"
          />
        ) : (
          <input
            style={{...style, cursor: !editable ? 'none' : 'pointer', pointerEvents: editable ? undefined : 'none'}}
            className={className}
            autoFocus={autoFocus}
            type="text"
            value={value}
            placeholder={placeholder}
            onClick={() => updateEditMode(true)}
            onChange={(event) => {
              onChange(event.target?.value ?? '')
            }}
          />
        )}
      </React.Fragment>
    </React.Fragment>
  )
}
